// extracted by mini-css-extract-plugin
module.exports = {"General":"MainText_General__3Chzk","HorizontalMode":"MainText_HorizontalMode__25Snq","VerticalMode":"MainText_VerticalMode__2UnTD","MobileMode":"MainText_MobileMode__1MnWg"};